<div class='container'>
  <div style="width: 100%; height: auto; overflow: visible;">
    
    <mat-tab-group [dynamicHeight]="true" style="height: auto; min-height: 500px; overflow: visible;">
      
      <!-- TAB ПРОЕКТ -->
      <mat-tab label="Проект">
        <hr>
        <form [formGroup]="project_form" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="form-group" class="row">
            <div class="col-10">
              <label>Название</label>
              <input type="text" formControlName="ShortTitle" class="form-control">
            </div>
          </div>
          <div class="col-2">
                    <!--SecurityLevel-->
                    
                    <label>Уровень секретности</label>
                    <select class="form-control" (change)="changeLevel($event)" formControlName="SecurityLevel">
                        <option *ngFor="let level of security_data" [ngValue]="level.ShortTitle" >
                            {{ level.ShortTitle }}
                        </option>
                    </select>
                </div>
          <div class="form-group">
            <label>Описание</label>
            <textarea name="Description" cols="40" rows="5" formControlName="Description"
                      class="form-control"></textarea>
          </div>
        </form>
      </mat-tab>
      
      <!-- TAB РАСЧЕТЫ -->
      <mat-tab label="Расчеты" [disabled]="ID===-1">
        <mat-toolbar>
          <span>
            <button mat-icon-button (click)="RefreshList()">
              <mat-icon>refresh</mat-icon>
            </button>
          </span>
          <span>
            <button mat-icon-button (click)="FunctionCreateCalculation()">
              <mat-icon>add</mat-icon>
            </button>
          </span>
        </mat-toolbar>

       
        <div class="mat-elevation-z8" style="overflow: visible !important; height: auto !important; min-height: 400px;">
          
          <mat-form-field>
            <mat-label>Фильтр</mat-label>
            <input matInput placeholder="Фильтр" (keyup)="Filterchange($event)">
          </mat-form-field>

          
          <table matSort mat-table [dataSource]="dataSourceCalculation" multiTemplateDataRows class="mat-elevation-z8">
                 class="mat-elevation-z8" 
                 style="display: table; width: 100%; border-collapse: collapse;">
            
            <!-- Expand Column -->
            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="toggleRow($event, element)">
                  <mat-icon>
                    {{ expandedElement === element ? 'expand_less' : 'expand_more' }}
                  </mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- ID Column -->
            <ng-container matColumnDef="ID">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let element">{{ element.ID }}</td>
            </ng-container>

            <!-- ShortTitle Column -->
            <ng-container matColumnDef="ShortTitle">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Название</th>
              <td mat-cell *matCellDef="let element">{{ element.ShortTitle }}</td>
            </ng-container>

            <!-- Module Column -->
            <ng-container matColumnDef="Module">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Модуль</th>
              <td mat-cell *matCellDef="let element">{{ element.Module }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="Status">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>Статус</th>
              <td mat-cell *matCellDef="let element">{{ element.Status }}</td>
            </ng-container>

            <!-- Edit Column -->
            <ng-container matColumnDef="Edit">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faPen"></fa-icon>
              </th>
              <td mat-cell *matCellDef="let element">
                <button (click)="FunctionEdit($event, element)" mat-button>
                  <fa-icon [icon]="faPen" style="color: darkred;"></fa-icon>
                </button>
              </td>
            </ng-container>

            <!-- View Column -->
            <ng-container matColumnDef="View">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faEye"></fa-icon>
              </th>
              <td mat-cell *matCellDef="let element">
                <button (click)="FunctionView($event, element)" mat-button>
                  <fa-icon [icon]="faEye" style="color: darkred;"></fa-icon>
                </button>
              </td>
            </ng-container>

            <!-- Remove Column -->
            <ng-container matColumnDef="Remove">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faTrash"></fa-icon>
              </th>
              <td mat-cell *matCellDef="let element">
                <button (click)="FunctionRemove($event, element)" mat-button>
                  <fa-icon [icon]="faTrash" style="color: darkred;"></fa-icon>
                </button>
              </td>
            </ng-container>

            <!-- Launch Column -->
            <ng-container matColumnDef="Launch">
              <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faPlay"></fa-icon>
              </th>
              <td mat-cell *matCellDef="let element">
                <button (click)="FunctionLaunch($event, element)" mat-button>
                  <fa-icon [icon]="faPlay" style="color: darkred;"></fa-icon>
                </button>
              </td>
            </ng-container>
<ng-container matColumnDef="expandedDetail" when >
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <table>
                      <div *ngIf="element.loading" class="loading-spinner">
                        <mat-spinner diameter="30"></mat-spinner>
                        <span>Загрузка...</span>
                      </div>

                      <div *ngIf="!element.loading && element.moduleFiles && element.moduleFiles.length > 0" 
                           class="files-list-items">
                        <div *ngFor="let file of element.moduleFiles" class="file-item">
                          <span class="file-name">
                            <mat-icon class="file-icon">description</mat-icon>
                            {{ file.ShortTitle }}
                          </span>
                          <button mat-icon-button 
                                  color="primary"
                                  (click)="downloadModuleFile($event, file)"
                                  [disabled]="isDownloading"
                                  matTooltip="Скачать">
                            <mat-icon>cloud_download</mat-icon>
                          </button>
                        </div>
                      </div>

                      <div *ngIf="!element.loading && (!element.moduleFiles || element.moduleFiles.length === 0)" 
                           class="no-files">
                        <mat-icon>folder_open</mat-icon>
                        <span>Файлы не найдены</span>
                      </div>
                    </table>
                </div>
            </td>
        </ng-container>
<tr mat-header-row *matHeaderRowDef="displayedColumnsWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsWithExpand;" class="example-element-row" [class.example-expanded-row]="expandedElement === element" (click)="toggleRow($event, element)">
        </tr>

        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow" class="example-detail-row"></tr>
    </table>
            
          

          <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25,100]" showFirstLastButtons>
          </mat-paginator>
       </div>
      </mat-tab>
    </mat-tab-group>
    
    <button mat-button type="submit" class="btn btn-primary">Сохранить</button>
    <button mat-raised-button color="warn" style="display:inline-block" (click)="exit()">Закрыть</button>
  </div>
</div>